import React from "react";
import Button from "../../../../../../../common/Button";

const KeypadChangeButton = ( props ) => {

  return (
    <Button className="pen btn-chg-num blue" onClick={ props.onChangeKeypad }>
      <img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_num_blue.svg` } alt="" />
    </Button>
  );

};

export default KeypadChangeButton;
